import classNames from 'clsx';
import type { ReactElement } from 'react';
import React from 'react';

import NoDataIcon from '../assets/no-data.svg';

import styles from './NoData.scss';

interface Props {
  className?: string;
  icon?: ReactElement;
  primaryText: React.ReactNode;
  secondaryText: React.ReactNode;
}

const NoData: React.FC<Props> = ({
  icon = <NoDataIcon />,
  primaryText,
  secondaryText,
  className
}) => (
  <div className={classNames(styles.container, className)} data-testid="no-data">
    <div className={styles.icon}>{icon}</div>
    <div className={styles.primaryText}>{primaryText}</div>
    <div className={styles.secondaryText}>{secondaryText}</div>
  </div>
);

export default NoData;
